import styled from "styled-components";

export const H1 = styled.div`
  font-size: var(--wp--preset--font-size--headline-1, 42px);
  line-height: 1.14;
  letter-spacing: -1px;
  font-weight: 700;
`;

export const H2 = styled.div`
  font-size: var(--wp--preset--font-size--headline-2, 34px);
  line-height: 1.23;
  font-weight: 700;
`;

export const H3 =styled.div`
  font-size: var(--wp--preset--font-size--headline-3, 24px);
  line-height: 1.25;
  font-weight: 700;
`;

export const H4 =styled.div`
  font-size: var(--wp--preset--font-size--headline-4, 20px);
  line-height: 1.3;
  font-weight: 700;
`;

export const H5 =styled.div`
  font-size: var(--wp--preset--font-size--headline-5, 18px);
  line-height: 1.3;
  font-weight: 700;
`;

export const PBold = styled.p`
    font-weight: 700;
    color: var(--wp--preset--color--blue-700);
`;

export const PSmall = styled.p`
    font-weight: 400;
`;